<template>
  <div class="bq-job">
    <header>
      <div
        class="bq-job-avatar"
        :style="{ 'background-color': `#${job.color}` }"
      >
        <img :src="job.micon" :alt="job.name" />
      </div>
      <h2>{{ job.name }}</h2>
    </header>

    <article
      class="bq-job-mod"
      v-for="item in job.description"
      :key="item.title"
    >
      <h4>{{ item.title }}</h4>
      <p v-for="cell in item.content" :key="cell">{{ cell }}</p>
    </article>

    <footer>
      <a class="bq-mail-btn" :href="`mailto:${email}`" target="_blank">
        {{ email }}
      </a>
    </footer>
  </div>
</template>

<script>
import { aboutData } from '../About/about.js';

export default {
  name: 'job',

  data() {
    const { query } = this.$route;
    let { id: jobIdx } = query;

    if (!jobIdx || Number(jobIdx) >= aboutData.jobs.length) {
      jobIdx = 0;
    }

    const job = aboutData.jobs[jobIdx];

    return {
      job,
      email: aboutData.info.email,
    };
  },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
